import type { ReactNode } from 'react';

interface PanelProps {
  title?: string;
  children: ReactNode;
  className?: string;
}

export function Panel({ title, children, className = '' }: PanelProps) {
  return (
    <section className={`bg-white border border-border rounded-lg p-6 mb-6 ${className}`}>
      {title && <h2 className="text-lg mb-4">{title}</h2>}
      {children}
    </section>
  );
}
